import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Phone, Mail, MapPin, Linkedin, Instagram } from 'lucide-react';
import { brandAssets, whatsappNumber } from '../data/mockData';

export const Footer = () => {
  const { language } = useLanguage();
  const t = language === 'fr';

  const links = [
    { path: '/', label: t ? 'Accueil' : 'Home' },
    { path: '/produits', label: t ? 'Produits' : 'Products' },
    { path: '/tracabilite', label: t ? 'Traçabilité' : 'Traceability' },
    { path: '/diallo', label: t ? 'Réseau Diallo' : 'Diallo Network' },
    { path: '/b2b', label: t ? 'Professionnels' : 'Business' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <footer className="bg-[#1A5C38] text-white">
      <div className="container py-12">
        <div className="grid md:grid-cols-3 gap-8">
          
          {/* Brand */}
          <div>
            <img 
              src={brandAssets.logo} 
              alt="Océana" 
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-white/70 text-sm leading-relaxed">
              {t 
                ? 'Fruits & légumes frais à Abidjan. Qualité, traçabilité, proximité.'
                : 'Fresh fruits & vegetables in Abidjan. Quality, traceability, proximity.'}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              {links.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-white/70 hover:text-[#F5A623] transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={`tel:${whatsappNumber}`} className="flex items-center gap-2 text-white/70 hover:text-[#F5A623] transition-colors">
                  <Phone size={14} />
                  {whatsappNumber}
                </a>
              </li>
              <li>
                <a href="mailto:contact@oceana-ci.com" className="flex items-center gap-2 text-white/70 hover:text-[#F5A623] transition-colors">
                  <Mail size={14} />
                  contact@oceana-ci.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-white/70">
                <MapPin size={14} />
                Abidjan, Côte d&apos;Ivoire
              </li>
            </ul>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#F5A623] transition-colors">
                <Linkedin size={14} />
              </a>
              <a href="#" className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#F5A623] transition-colors">
                <Instagram size={14} />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container py-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-white/50">
            <span>© 2024 Océana. {t ? 'Tous droits réservés.' : 'All rights reserved.'}</span>
            <span>Made by Océana — Powered by Emergent</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
